import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export type BadgeTone =
  'neutral' | 'success' | 'warning' | 'info' | 'danger' | 'brand';

interface BadgeProps {
  tone?: BadgeTone;
  /** Leading status dot, as on "● Active" / "● In room" in the artifact. */
  dot?: boolean;
  /** Small leading icon (e.g. assistance needs). */
  icon?: ReactNode;
  children: ReactNode;
}

export function Badge({ tone = 'neutral', dot, icon, children }: BadgeProps) {
  return (
    <span className={[styles.badge, styles[tone]].join(' ')}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {icon}
      {children}
    </span>
  );
}

/** Nav/count badge: small dark pill with a number (sidebar items). */
export function CountBadge({
  count,
  label,
}: {
  count: number;
  label?: string;
}) {
  if (count <= 0) return null;
  return (
    <span className={styles.count} aria-label={label ?? `${count}`}>
      {count > 99 ? '99+' : count}
    </span>
  );
}
